import { LocaleContext } from 'components/MainComponent/MainComponent'
import { useContext } from 'react'
import styled from 'styled-components'

export const AbbauChart_MOBIL = ({
  hlColor,
  curveColor,
}: {
  hlColor: string
  curveColor: string
}) => {
  const TEXT = useContext(LocaleContext).abbauchart
  return (
    <StyledAbbauChart viewBox='0 0 530 320'>
      <path
        d='M202.832,275.489v6.966m50.565-6.985v7.265m155.724-7.25v6.966m-52.096-6.966v6.966m-52.839-7v7.284m-153.607-7.271v7.271m-51.195-7.271v7.271'
        fill='none'
        stroke={hlColor}
        strokeWidth='.75'
      />
      <path
        d='M51.865,143.542l275.128,.012'
        fill='none'
        stroke={hlColor}
        strokeDasharray='0 0 0 6'
        strokeLinecap='round'
        strokeWidth='1.5'
      />
      <line
        x1='51.865'
        y1='10.771'
        x2='140.061'
        y2='10.771'
        fill='none'
        stroke={hlColor}
        strokeDasharray='0 0 0 6'
        strokeLinecap='round'
        strokeWidth='1.5'
      />
      <g>
        <path
          d='M51.425,274.365S119.234,12.596,150.577,12.596c47.538,0,343.42,262.764,343.42,262.764'
          fill='none'
          stroke={curveColor}
          strokeWidth='4'
        />
        <line
          x1='47.377'
          y1='274.642'
          x2='512.874'
          y2='274.642'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
        <path
          d='M460.222,275.497v7.237m-.472-7.237v7.237'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
        <line
          x1='512.874'
          y1='275.327'
          x2='512.874'
          y2='282.735'
          fill='none'
          stroke={hlColor}
          strokeWidth='.75'
        />
      </g>
      <text transform='translate(44.321 304.016)' fill={hlColor}>
        <tspan x='0' y='0' textAnchor='middle'>
        {TEXT[2]}
        </tspan>
      </text>
      <text transform='translate(94.884 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          1
        </tspan>
      </text>
      <text transform='translate(146.079 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          2
        </tspan>
      </text>
      <text transform='translate(198.332 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          3
        </tspan>
      </text>
      <text transform='translate(249.526 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          4
        </tspan>
      </text>
      <text transform='translate(299.686 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          5
        </tspan>
      </text>
      <text transform='translate(350.88 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          6
        </tspan>
      </text>
      <text transform='translate(404.621 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          7
        </tspan>
      </text>
      <text transform='translate(455.815 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          8
        </tspan>
      </text>
      <text transform='translate(506.369 304.016)' fill='#9698a8'>
        <tspan x='0' y='0'>
          9
        </tspan>
      </text>
      <text transform='translate(0 12.735)' fill='#9698a8'>
        <tspan x='0' y='0'>
          1,0‰
        </tspan>
      </text>
      <text transform='translate(0 146.762)' fill='#9698a8'>
        <tspan x='0' y='0'>
          0,5‰
        </tspan>
      </text>
    </StyledAbbauChart>
  )
}

const StyledAbbauChart = styled.svg`
  font-family: var(--font-sans-serif);
  font-size: 15px;
  max-width: 100%;
  padding:0;
`
